import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';
const { BASE_FONT_FAMILY } = constants;

let styles = {
  base: {
    width: '100%'
  },
  input: {
    fontWeight: 600,
    fontSize: '1em',
    fontFamily: BASE_FONT_FAMILY,
    color: '#666',
    padding: '10px 14px 10px 38px',
    height: 35,
    width: '100%',
    border: 0,
    borderRadius: 7,
    boxSizing: 'border-box',
    backgroundColor: '#eee',
    '::placeholder': {
      color: '#ccc'
    }
  },
  searchIcon: {
    position: 'relative',
    padding: 0,
    top: -26,
    left: 18,
    color: '#bbb'
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/inputs/searchinput/SearchInput.styles.js